import { render, staticRenderFns } from "./CoeReset.vue?vue&type=template&id=01b93486&functional=true&"
var script = {}
import style0 from "./CoeReset.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/viniazvd/vue-coe-calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01b93486')) {
      api.createRecord('01b93486', component.options)
    } else {
      api.rerender('01b93486', component.options)
    }
    module.hot.accept("./CoeReset.vue?vue&type=template&id=01b93486&functional=true&", function () {
      api.rerender('01b93486', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CoeReset.vue"
export default component.exports